import React from "react";

import NotificationSettings from "./NotificationSettings";
import PageHeader from "../../../shared/components/common/PageHeader";

const Notifications = () => {
  return (
    <div>
      <PageHeader
        title="Notifications"
        subtitle="Manage your notification preferences"
      />
      <NotificationSettings />
    </div>
  );
};

export default Notifications;
